module.exports = __webpack_public_path__ + "RG.png";


//////////////////
// WEBPACK FOOTER
// ./src/constants/icons/RG.png
// module id = 1439
// module chunks = 0